import type * as lazyIndex from './lazyIndex';
import { LazyBootModule, LazyAction } from 'owa-bundling-light';

const lazyModule: LazyBootModule<typeof lazyIndex> = new LazyBootModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "NativeAuthInterop" */ './lazyIndex'),
    { name: 'NativeAuthInterop' }
);

export const lazyGetAuthTokenForAccount: LazyAction<
    typeof lazyIndex.getAuthTokenForAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAuthTokenForAccount);

export const lazyGetAuthTokenForNewAccount: LazyAction<
    typeof lazyIndex.getAuthTokenForNewAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAuthTokenForNewAccount);

export const lazyGetAuthTokenNoPrompt: LazyAction<
    typeof lazyIndex.getAuthTokenNoPrompt,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getAuthTokenNoPrompt);

export const lazyGetUniqueIdentifierForLicensingAccount: LazyAction<
    typeof lazyIndex.getUniqueIdentifierForLicensingAccount,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getUniqueIdentifierForLicensingAccount);

export const lazyGetNestedAppAuthTokenForLicensingMailbox: LazyAction<
    typeof lazyIndex.getNestedAppAuthTokenForLicensingMailbox,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.getNestedAppAuthTokenForLicensingMailbox);
